import React from "react";
import people from "../../../assets/img/icons/people.svg";
import key from "../../../assets/img/icons/key.svg";
import clock from "../../../assets/img/icons/clock.svg";
import security from "../../../assets/img/icons/security-safe.svg";

const AboutPlace = ({ inforesidencedetail }) => {
  return (
    <div>
      <div className="AboutPlace my-[40px]">
        <div>
        <h5 className="text-[20px] font-[700] text-[#12171C] mb-[16px]">
            درباره اقامتگاه :
          </h5>
          <div className="AboutPlace--info grid grid-cols-2 ">
            <div className="flex justify-between items-center text-[18px] text-[#292D32]">
              <div className="font-[600]">متراژ زیر بنا :</div>
              <div className="font-[400] w-[64px] text-right">
                {inforesidencedetail.foundation_size} متر
              </div>
            </div>
            <div className="flex justify-between items-center text-[18px] text-[#292D32]">
              <div className="font-[600]">متراژ کل زمین :</div>
              <div className="font-[400] w-[64px] text-right">
                {inforesidencedetail.area_size} متر
              </div>
            </div>
            <div className="flex justify-between items-center text-[18px] text-[#292D32]">
              <div className="font-[600]">نوع اقامتگاه :</div>
              <div className="font-[400] w-[64px] text-right">
                {inforesidencedetail.type.title}
              </div>
            </div>
            <div className="flex justify-between items-center text-[18px] text-[#292D32]">
              <div className="font-[600]">بافت محیطی :</div>
              <div className="font-[400] w-[64px] text-right">
              {inforesidencedetail.environment_texture.map(i=>i)} 
              </div>
            </div>
            </div>
            <h5 className="text-[20px] font-[700] text-[#12171C] mb-[16px] mt-[30px]">
            سرویس بهداشتی : 
          </h5>
          <div className="AboutPlace--info grid grid-cols-2 ">
            <div className="flex justify-between items-center text-[18px] text-[#292D32]">
              <div className="font-[600]">حمام :</div>
              <div className="font-[400] w-[64px] text-right">۱ حمام</div>
            </div>
            <div className="flex justify-between items-center text-[18px] text-[#292D32]">
              <div className="font-[600]">توالت فرنگی :</div>
              <div className="font-[400] w-[64px] text-right">۱ سرویس</div>
            </div>
            <div className="flex justify-between items-center text-[18px] text-[#292D32]">
              <div className="font-[600]">توالت ایرانی :</div>
              <div className="font-[400] w-[64px] text-right">۱ سرویس</div>
            </div>
            <div className="flex justify-between items-center text-[18px] text-[#292D32]">
              <div className="font-[600]">تعداد اتاق :</div>
              <div className="font-[400] w-[64px] text-right">
                {inforesidencedetail.rooms_count} اتاق
              </div>
            </div>
            </div>
            <h5 className="text-[20px] font-[700] text-[#12171C] mb-[16px] mt-[30px]">
            ظرفیت اقامتگاه :
          </h5>
          <div className="AboutPlace--info grid grid-cols-2 ">
            <div className="flex justify-between items-center text-[18px] text-[#292D32]">
              <div className="font-[600]">تخت ۲ نفره :</div>
              <div className="font-[400] w-[64px] text-right">۱ تخت</div>
            </div>
            <div className="flex justify-between items-center text-[18px] text-[#292D32]">
              <div className="font-[600]">تخت ۱ نفره :</div>
              <div className="font-[400] w-[64px] text-right">۲ تخت</div>
            </div>
            <div className="flex justify-between items-center text-[18px] text-[#292D32]">
              <div className="font-[600]">ظرفیت استاندارد :</div>
              <div className="font-[400] w-[64px] text-right">
                {inforesidencedetail.capacity} مهمان
              </div>
            </div>
            <div className="flex justify-between items-center text-[18px] text-[#292D32]">
              <div className="font-[600]">حداکثر جمعیت :</div>
              <div className="font-[400] w-[64px] text-right">
                {inforesidencedetail.max_capacity} مهمان
              </div>
            </div>
            <div className="flex lastinfo justify-between items-center text-[18px] text-[#292D32]">
              <div className="font-[600]">تعداد رخت خواب سنتی ( تشک ) :</div>
              <div className="font-[400] w-[64px] text-right">۴ عدد</div>
            </div>
            </div>
       
      
        </div>
        <div className="AboutPlace--imginfo grid grid-cols-2 ">
          <div className="AboutPlace-box ">
            <img src={people} />
            <p className="font-[500] text-[16px] text-[#797D82]">
              حداکثر ظرفیت :
            </p>
            <p className="font-[700] text-[20px] text-[#292D32]">
              {inforesidencedetail.max_capacity} مهمان
            </p>
          </div>
          <div className="AboutPlace-box ">
            <img src={key} />
            <p className="font-[500] text-[16px] text-[#797D82]">
              فضای اقامتگاه
            </p>
            <p className="font-[700] text-[20px] text-[#292D32]">
              {" "}{inforesidencedetail.space}
            </p>
          </div>
          <div className="AboutPlace-box ">
            <img src={clock} />
            <p className="font-[500] text-[16px] text-[#797D82]">
              حداقل مدت اقامت :
            </p>
            <p className="font-[700] text-[20px] text-[#292D32]">
              {" "}{inforesidencedetail.regulation.min_stay} شب
            </p>
          </div>
          <div className="AboutPlace-box ">
            <img src={security} />
            <p className="font-[500] text-[16px] text-[#797D82]">
              سرایدار / نگهبان :
            </p>
            {inforesidencedetail.have_janitor === 1
              ? <p className="font-[700] text-[20px] text-[#292D32]">دارد </p>
              : <p className="font-[700] text-[20px] text-[#292D32]" >ندارد</p>}
          </div>

      </div>
    </div>
    </div>
  );
};

export default AboutPlace;
